import A from 'utils/metrics/analytic'
// ==== Общие события для Раздела "Библиотека" на портале

// Заход на страницу "Раздел Библиотека" и  переключение вкладок
enum sectionName {
  ARTICLE = 'article',
  VIDEO = 'video',
  CLINREC = 'clinrec',
  PODCAST = 'podcast',
}

const A_l_sectionToggle = (type: sectionName) => {
  A.setEvent('library_section_open', { type })
}

export { A_l_sectionToggle, sectionName }
